import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface ErrorListProps {
  className?: string
  id?: string
  errors: Array<React.ReactElement | string>
}

const ErrorList: React.FC<ErrorListProps> = (props): React.ReactElement => {
  return (
    <div
      id={props.id}
      role="alert"
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        padding: 5px 20px;
        white-space: pre-wrap;
        gap: 4px;
      `}
    >
      {props.errors.map((err, i) => (
        <span
          key={i}
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.red,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          {err}
        </span>
      ))}
    </div>
  )
}

export default ErrorList
